import { SnackbarContent, Typography } from '@material-ui/core'
import React, { forwardRef } from 'react'
import { useStyle } from './snackbar.style'
import { CheckedBrokenSvg } from '../icons'

const SNACKBAR_TYPE = {
	success: 'success',
	error: 'error',
	info: 'info',
	warning: 'warning',
}

export const SnackbarCustomization = forwardRef((props, ref) => {
	const classes = useStyle()
	const { id, message, variant, ...other } = props

	if (variant === SNACKBAR_TYPE.success) {
		return (
			<SnackbarContent
				ref={ref}
				classes={{ root: classes.root, action: classes.action }}
				action={
					<>
						<CheckedBrokenSvg />
						<Typography variant="subtitle2" className="message">
							{message}
						</Typography>
					</>
				}
				{...other}
			/>
		)
	}
	return null
})
